import { SummaryViewStepStatus } from '@areapif/areapif-shared'

export interface StepStatusStyle {
  backgroundColor: string
  borderColor: string
  iconColor: string
}

/**
 * Same palette as the mobile app's step icons: green once evidence is in, blue
 * for the step being worked on, red for a step that was skipped in a phase
 * already left behind, grey for what is still ahead.
 *
 * Shared by the header's step strip and the step galleries below it, so the
 * two never tell the operator different things about the same step.
 */
export const STEP_STATUS_STYLES: Record<SummaryViewStepStatus, StepStatusStyle> = {
  [SummaryViewStepStatus.DONE_COMPLETE]: { backgroundColor: '#10b981', borderColor: '#10b981', iconColor: '#ffffff' },
  [SummaryViewStepStatus.ACTIVE]: { backgroundColor: '#3b82f6', borderColor: '#3b82f6', iconColor: '#ffffff' },
  [SummaryViewStepStatus.DONE_MISSING]: { backgroundColor: '#fef2f2', borderColor: '#ef4444', iconColor: '#ef4444' },
  [SummaryViewStepStatus.TODO]: { backgroundColor: 'transparent', borderColor: '#9ca3af', iconColor: '#9ca3af' },
}
